// src/pages/marketplace/OrderCancel.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export default function OrderCancel() {
  return (
    <div style={{ maxWidth: 600, margin: '4rem auto', textAlign: 'center', padding: '2rem' }}>
      <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>⚠️</div>
      <h1 style={{ fontSize: '2rem', fontWeight: 700, color: '#ef4444' }}>Payment Cancelled</h1>
      <p style={{ color: '#aaa', marginTop: '1rem', lineHeight: 1.6 }}>
        Your payment process was interrupted or cancelled. No charges were made.
        You can try again anytime by using the secure link emailed to you by the artist.
      </p>

      <div style={{ marginTop: '2.5rem' }}>
        <Link 
          to="/marketplace" 
          style={{
            padding: '0.8rem 1.5rem',
            background: '#333',
            color: '#fff',
            textDecoration: 'none',
            borderRadius: '0.5rem',
            fontWeight: 600
          }}
        >
          Return to Marketplace
        </Link>
      </div>
    </div>
  );
}
